import FieldNames from "../defaults/FieldNames.json";
import {formatDateForDisplay} from './DateHelper';
import fieldsDefinition from '../components/details/FieldInfo.json';
import {isFeaturePostFire, isFeatureTreatment} from "./FeatureHelper";

export const establishGridColumns = (columnDefinitions, setGridColumns, colOverrideDefinitions) => {
  let columns = [];
  columnDefinitions.forEach((colDef) => {
    columns.push({
      field: colOverrideDefinitions?.value ?? colDef.value ?? "DEFAULT",
      headerName: colOverrideDefinitions?.headerName ?? colDef.header ?? "DEFAULT",
      type: colOverrideDefinitions?.type ?? colDef.type ?? "string",
      hideable: colOverrideDefinitions?.hideable ?? colDef.hideable ?? false,
      sortable: colOverrideDefinitions?.sortable ?? colDef.sortable ?? false,
      editable: colOverrideDefinitions?.editable ?? colDef.editable ?? false,
      groupable: colOverrideDefinitions?.groupable ?? colDef.groupable ?? false,
      flex: colOverrideDefinitions?.flex ?? colDef.flex ?? 1.0,
      align: colOverrideDefinitions?.align ?? colDef.align ?? "left",
      disableExport: colOverrideDefinitions?.disableExport ?? colDef.disableExport ?? false,
      valueGetter: ((value) => {
        return value; // Used for formatting string values I.E. currency formatting
      }),
      valueParser: ((value, row, column, apiRef) => {
        return colOverrideDefinitions?.valueParser(value, row, column, apiRef) ?? value;
      }),
      renderCell: colOverrideDefinitions?.renderCell
    });
  });

  setGridColumns(columns);
};

const getNameOfOption = (value, field, transitionBetweenValues) => {
  const trimmedValue = value ? value.trim() : "";
  const noSingleQuotesTrimmedValue = trimmedValue ? trimmedValue.replaceAll("'", "") : "";
  const currentfieldInfo = fieldsDefinition[field];
  let selectedValue = "";
  const domain = currentfieldInfo.domain;
  if(domain){
    const codedValues = domain.codedValues;
    if(codedValues && codedValues.length > 0){
      const selectedItem = codedValues.filter(item => item.code === value || item.code === noSingleQuotesTrimmedValue);
      if(selectedItem.length > 0){
        let selectedItemName = selectedItem[0].name;
        selectedValue = selectedItemName;
      } 
    }
  }
  return selectedValue;
}  

export const formatResponse = (row, element) => {
  if(row){
    if(element === FieldNames.featureFields.priority || element === FieldNames.featureFields.feasibility){
      return `${getNameOfOption(row[element], element, FieldNames.transitionBetweenValues)}`;
    } else if(element === FieldNames.featureFields.class){
      if(row[element] === FieldNames.classTypes.treatment){
        return "Treatment";
      } else if(row[element] === FieldNames.classTypes.activity){
        return "Activity";
      } else {
        return "";
      }
    } else if(element === "GroupingID"){
      if(row[FieldNames.featureFields.name] !== null && row[FieldNames.featureFields.name] !== "" && row[FieldNames.featureFields.name] !== undefined)
      {
        return `${row[FieldNames.featureFields.name]}`;
      }
      else
      {
        return "";
      }       
    } else if(element === "ID"){
      if(row && row[element]){
        return `${row[element]}`
      } else {
        return ''
      }
      
    } else if(element === FieldNames.featureFields.estimatedSuccessProbability) {
      if(row[element]){
        return `${getNameOfOption(row[element], element, FieldNames.transitionBetweenValues)}%`;
      } else {
        return ``
      }
    } else if(element === FieldNames.featureFields.isRTRL)
    {
      if(row?.rowNode?.type === "leaf")
      {
        if(!row[element]){
          return 'No'
        } else {
          return row[element]
        }
      }
      else{
        if(row[element]){
          return row[element]
        } else {
          return ``;
        }
      }
    } else if(element === FieldNames.featureFields.localApprovalDate || element === FieldNames.featureFields.regionalApprovalDate ||
      element === FieldNames.featureFields.agencyApprovalDate || element === FieldNames.featureFields.departmentApprovalDate){
      if(row[element]){
        return formatDateForDisplay(row[element])
        
      } else {
        return ``
      }
    } else if(element === FieldNames.featureFields.estimatedTotalCost ||
      element === FieldNames.featureFields.estimatedAssetCost ||
      element === FieldNames.featureFields.estimatedContractualCost ||
      element === FieldNames.featureFields.estimatedGrantsFixedCost ||
      element === FieldNames.featureFields.estimatedOtherCost ||
      element === FieldNames.featureFields.estimatedPersonnelCost) {
      if(row[element]){
        return `$${row[element]}`;
      } else {
        return ``
      }
    } else {
      if(row[element]){
        return `${row[element]}`;
      } else {
        return ``
      }
    }
  } else {
    return ``;
  }
}

export const getURLPath = (row, element) => {
  if(element === "ID"){
    if(row[FieldNames.featureFields.class] !== null && row[FieldNames.featureFields.class] !== "")
    {
      const objectId = row[FieldNames.featureFields.objectID]
      const isTreatment = isFeatureTreatment(false, row, FieldNames.featureFields);
      const isPostFire = isFeaturePostFire(row, false);
      const entityString = isTreatment ? "treatments" : "activities";
      const entityTypeString = isPostFire ? "pf" : "f";
      return `../${entityTypeString}/${entityString}/${objectId}`;
    }
    else
    {
      return "";
    }       
  } 
}